<template>
  <div class="feedback" v-if="content">
    <ul :style="listStyle" class="list">
      <li v-for="item in content.items" :key="item._uid">
        <img :src="item.img" :alt="item.title">
        <p>
          " {{item.text}} "
        </p>
      </li>
    </ul>
    <ul class="dots">
      <li @click="currentIndex = i" :class="i === currentIndex ? 'active' : ''" v-for="(item, i) in content.items" :key="i">
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      content: null
    },
    computed: {
      listStyle() {
        let width = this.content.items.length * 100 + "%"
        let currentPos = `translateX(-${this.currentIndex * 100}vw)`
        return {
          width: width,
          transform: currentPos
        }
      }
    },
    data() {
      return {
        currentIndex: 0,
      }
    }
  };
</script>

<style lang="scss">
  .feedback {
    overflow:hidden;
    .list {
      display: flex;
      transition: transform 0.4s;
      margin:2em 0;
      > li {
        display: flex;
        align-items: center;
        justify-content: center;
        width:100vw;
        img {
          height:100px;
          width:auto;
        }
        p {
          color:$black;
        }
      }
    }
    .dots {
      display: flex;
      justify-content: center;
      li {
        width:20px;
        height:20px;
        background-color:#fff;
        border:1px solid $black;
        border-radius:50%;
        margin:0 10px;
        cursor:pointer;
        &.active {
          background-color:$black;
        }
      }
    }
  }
</style>
